const initState = {
  authError: null,
};

const authReducer = (state = initState, action) => {
  switch (action.type) {
    case "LOGIN_ERROR":
      return {
        ...state,
        authError: "Login failed",
      };
    case "LOGIN_SUCCESS":
      console.log("login success");
      return {
        ...state,
        authError: null,
      };
    case "SIGNOUT_SUCCESS":
      console.log("user logout");
      return state;

    case "SIGNUP_SUCCESS":
      console.log("SIGNUP_SUCCESS");
      return {
        ...state,
        authError: null,
      };
    case "SIGNUP_ERROR":
      console.log("SIGNUP_ERROR");
      return {
        ...state,
        authError: action.err.message,
      };

    case "FORGOT_PASSWORD_SUBMITTED":
      console.log("FORGOT_PASSWORD_SUBMITTED");
      return {
        ...state,
        authError: null,
      };
    case "FORGOT_PASSWORD_ERROR":
      console.log("FORGOT_PASSWORD_ERROR");
      return {
        ...state,
        authError: action.err.message,
      };
    default:
      return state;
  }
};

export default authReducer;
